import { Link } from 'react-router-dom';

const STATS = [
  { value: '2019', label: 'Founded' },
  { value: '50K+', label: 'Happy Customers' },
  { value: '10+', label: 'Cities Reached' },
  { value: '100%', label: 'Made in Bengal' },
];

const VALUES = [
  { icon: '🧵', title: 'Artisan Craft', body: 'Every piece is crafted by skilled Bengali weavers and tailors who carry generations of textile wisdom.' },
  { icon: '🌿', title: 'Sustainability', body: 'We use natural dyes, organic cotton, and responsible sourcing at every step of production.' },
  { icon: '🏙️', title: 'Street Culture', body: 'Born in the lanes of North Kolkata — our designs speak the language of addas, para, and para-culture.' },
  { icon: '❤️', title: 'Community First', body: 'We reinvest in local artisan communities, ensuring fair wages and safe working conditions.' },
  { icon: '🎨', title: 'Bold Identity', body: 'Bhadralok is a statement — unabashedly Bengali, proudly modern, fiercely independent.' },
  { icon: '✈️', title: 'Global Reach', body: 'Our roots are in Kolkata, but we ship to 150+ countries — wherever the Bengali diaspora lives.' },
];

const TIMELINE = [
  { year: '2019', event: 'Founded in a tiny studio in Shyambazar, North Kolkata with just 3 designs.' },
  { year: '2020', event: 'Survived the pandemic by going fully online. First 1000 orders shipped.' },
  { year: '2021', event: 'Launched the signature Dhoti Collection. Featured in Scroll India.' },
  { year: '2022', event: 'Expanded to Mumbai, Delhi, and Bangalore. 10,000 customers milestone.' },
  { year: '2023', event: 'Opened the Bhadralok Studio flagship in College Street, Kolkata.' },
  { year: '2024', event: 'International shipping to 50+ countries. Collaboration with Biswa Bangla.' },
];

const TEAM = [
  { name: 'Arnab Chatterjee', role: 'Founder & Creative Director', initial: 'A' },
  { name: 'Priya Bose', role: 'Head of Design', initial: 'P' },
  { name: 'Subhadeep Roy', role: 'Head of Operations', initial: 'S' },
  { name: 'Ritika Sen', role: 'Brand & Marketing', initial: 'R' },
];

export default function About() {
  return (
    <div className="page-top">
      {/* Hero */}
      <div style={S.hero}>
        <div style={S.heroLeft}>
          <p className="sec-label" style={{ color: 'var(--gold)', marginBottom: '16px' }}>Est. 2019 · Kolkata, West Bengal</p>
          <h1 style={S.heroTitle}>THE BHADRALOK<br />STORY</h1>
          <p style={S.heroSub}>We didn't set out to build a fashion brand. We set out to celebrate who we are — unapologetically Bengali, relentlessly creative, and deeply proud.</p>
          <div style={S.statsRow}>
            {STATS.map((s) => (
              <div key={s.label} style={S.stat}>
                <span style={S.statVal}>{s.value}</span>
                <span style={S.statLbl}>{s.label}</span>
              </div>
            ))}
          </div>
        </div>
        <div style={S.heroRight}>
          <div style={S.heroImgBox}>
            <img src="https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&q=80" alt="Bhadralok Studio" style={S.heroImg} />
            <div style={S.heroImgBadge}>
              <p style={{ fontFamily: 'var(--font-script)', fontSize: '20px', color: 'var(--gold)', margin: 0 }}>Cha, Adda, Identity</p>
            </div>
          </div>
        </div>
      </div>

      {/* Origin Story */}
      <div style={S.origin}>
        <div style={S.originImg}>
          <div style={S.originImgMain}>
            <img src="https://images.unsplash.com/photo-1606041011872-596597976b25?w=500&q=80" alt="Origin" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          </div>
          <div style={S.originImgOver}>
            <p style={{ fontFamily: 'var(--font-display)', fontSize: '28px', letterSpacing: '2px', color: '#fff', margin: '0 0 4px' }}>NORTH KOLKATA</p>
            <p style={{ fontFamily: 'var(--font-script)', fontSize: '16px', color: 'var(--gold)', margin: 0 }}>Where it all began</p>
          </div>
        </div>
        <div style={S.originText}>
          <p className="sec-label" style={{ marginBottom: '12px' }}>Our Origin</p>
          <h2 style={S.secTitle}>FROM AN <em style={{ color: 'var(--red)', fontStyle: 'italic' }}>ADDA</em><br />TO YOUR WARDROBE</h2>
          <p style={S.bodyText}>It started with a conversation at a dhaba in Shyambazar — three friends, two cups of cha, and one big question: why is there no clothing brand that speaks our language?</p>
          <p style={S.bodyText}>Kolkata has always had its own aesthetic. The intellectual Bhadralok, the rebellious para-youth, the artist who sketches between classes at Presidency. We wanted to dress that person.</p>
          <p style={S.bodyText}>We partnered with weavers from Shantipur, printers from Barabazar, and tailors from Gariahat. Every piece tells a story that goes back decades.</p>
          <Link to="/products" style={S.cta}>EXPLORE COLLECTION →</Link>
        </div>
      </div>

      {/* Values */}
      <div style={S.valuesSection}>
        <div style={{ textAlign: 'center', marginBottom: '56px' }}>
          <p className="sec-label" style={{ marginBottom: '10px' }}>What We Stand For</p>
          <h2 style={{ ...S.secTitle, textAlign: 'center' }}>OUR <em style={{ color: 'var(--red)', fontStyle: 'italic' }}>VALUES</em></h2>
        </div>
        <div style={S.valuesGrid}>
          {VALUES.map((v) => (
            <div key={v.title} style={S.valueCard}>
              <div style={S.valueIcon}>{v.icon}</div>
              <h3 style={S.valueTitle}>{v.title}</h3>
              <p style={{ fontSize: '13px', color: '#666', lineHeight: 1.7 }}>{v.body}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Timeline */}
      <div style={S.timelineSection}>
        <div style={{ textAlign: 'center', marginBottom: '56px' }}>
          <p className="sec-label" style={{ color: 'var(--gold)', marginBottom: '10px' }}>Our Journey</p>
          <h2 style={{ ...S.secTitle, color: '#fff', textAlign: 'center' }}>FIVE YEARS OF <em style={{ color: 'var(--gold)', fontStyle: 'italic' }}>BHADRALOK</em></h2>
        </div>
        <div style={S.timeline}>
          {TIMELINE.map((t, i) => (
            <div key={t.year} style={{ ...S.tlItem, flexDirection: i % 2 === 0 ? 'row' : 'row-reverse' }}>
              <div style={{ ...S.tlContent, textAlign: i % 2 === 0 ? 'right' : 'left' }}>
                <p style={S.tlYear}>{t.year}</p>
                <p style={S.tlEvent}>{t.event}</p>
              </div>
              <div style={S.tlDot} />
              <div style={{ flex: 1 }} />
            </div>
          ))}
        </div>
      </div>

      {/* Team */}
      <div style={S.teamSection}>
        <div style={{ textAlign: 'center', marginBottom: '56px' }}>
          <p className="sec-label" style={{ marginBottom: '10px' }}>The People Behind It</p>
          <h2 style={{ ...S.secTitle, textAlign: 'center' }}>MEET THE <em style={{ color: 'var(--red)', fontStyle: 'italic' }}>TEAM</em></h2>
        </div>
        <div style={S.teamGrid}>
          {TEAM.map((t) => (
            <div key={t.name} style={S.teamCard}>
              <div style={S.teamAvatar}>{t.initial}</div>
              <p style={S.teamName}>{t.name}</p>
              <p style={S.teamRole}>{t.role}</p>
            </div>
          ))}
        </div>
      </div>

      {/* CTA Banner */}
      <div style={S.ctaBanner}>
        <p className="sec-label" style={{ color: 'var(--gold)', marginBottom: '12px' }}>Join the Movement</p>
        <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(28px,4vw,48px)', letterSpacing: '2px', color: '#fff', marginBottom: '24px' }}>BE A BHADRALOK</h2>
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/products" style={S.ctaBtnPrimary}>SHOP NOW →</Link>
          <Link to="/contact" style={S.ctaBtnOutline}>GET IN TOUCH</Link>
        </div>
      </div>
    </div>
  );
}

const S = {
  hero:          { background: 'var(--black)', display: 'grid', gridTemplateColumns: '1fr 1fr', minHeight: '80vh', overflow: 'hidden', borderBottom: '3px solid var(--gold)' },
  heroLeft:      { padding: '72px 56px', display: 'flex', flexDirection: 'column', justifyContent: 'center' },
  heroTitle:     { fontFamily: 'var(--font-display)', fontSize: 'clamp(36px,5vw,60px)', letterSpacing: '2px', color: '#fff', lineHeight: 1.05, marginBottom: '20px' },
  heroSub:       { fontSize: '15px', color: 'rgba(255,255,255,.6)', lineHeight: 1.8, maxWidth: '420px', marginBottom: '40px' },
  statsRow:      { display: 'flex', gap: '32px', flexWrap: 'wrap' },
  stat:          { display: 'flex', flexDirection: 'column' },
  statVal:       { fontFamily: 'var(--font-display)', fontSize: '28px', letterSpacing: '2px', color: 'var(--gold)', lineHeight: 1 },
  statLbl:       { fontSize: '10px', fontWeight: 700, letterSpacing: '1.5px', textTransform: 'uppercase', color: 'rgba(255,255,255,.4)', marginTop: '4px' },
  heroRight:     { position: 'relative', overflow: 'hidden' },
  heroImgBox:    { width: '100%', height: '100%', position: 'relative' },
  heroImg:       { width: '100%', height: '100%', objectFit: 'cover', opacity: .7 },
  heroImgBadge:  { position: 'absolute', bottom: '32px', left: '32px', background: 'rgba(0,0,0,.7)', border: '1px solid rgba(255,255,255,.15)', padding: '12px 20px', backdropFilter: 'blur(8px)' },
  origin:        { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '72px', padding: '96px 56px', alignItems: 'center', background: '#fff' },
  originImg:     { position: 'relative', height: '460px' },
  originImgMain: { width: '100%', height: '100%', overflow: 'hidden' },
  originImgOver: { position: 'absolute', bottom: 0, left: 0, right: 0, background: 'linear-gradient(to top, rgba(0,0,0,.8), transparent)', padding: '32px 24px 24px' },
  originText:    {},
  secTitle:      { fontFamily: 'var(--font-display)', fontSize: 'clamp(24px,3.5vw,40px)', letterSpacing: '2px', lineHeight: 1.1, marginBottom: '20px', color: 'var(--black)' },
  bodyText:      { fontSize: '14px', color: '#555', lineHeight: 1.85, marginBottom: '16px' },
  cta:           { display: 'inline-block', marginTop: '8px', background: 'var(--red)', color: '#fff', padding: '12px 28px', fontFamily: 'var(--font-body)', fontSize: '11px', fontWeight: 700, letterSpacing: '2px', textTransform: 'uppercase', textDecoration: 'none' },
  valuesSection: { padding: '96px 56px', background: 'var(--offwhite)' },
  valuesGrid:    { display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '20px' },
  valueCard:     { background: '#fff', border: '1px solid var(--border)', padding: '28px', transition: 'border-color .2s', cursor: 'default' },
  valueIcon:     { fontSize: '28px', marginBottom: '12px' },
  valueTitle:    { fontFamily: 'var(--font-display)', fontSize: '16px', letterSpacing: '2px', marginBottom: '10px' },
  timelineSection:{ padding: '96px 56px', background: 'var(--black)' },
  timeline:      { maxWidth: '700px', margin: '0 auto', position: 'relative', display: 'flex', flexDirection: 'column', gap: '32px' },
  tlItem:        { display: 'flex', alignItems: 'center', gap: '24px' },
  tlContent:     { flex: 1 },
  tlYear:        { fontFamily: 'var(--font-display)', fontSize: '24px', letterSpacing: '3px', color: 'var(--gold)', lineHeight: 1, marginBottom: '4px' },
  tlEvent:       { fontSize: '13px', color: 'rgba(255,255,255,.6)', lineHeight: 1.7 },
  tlDot:         { width: '14px', height: '14px', borderRadius: '50%', background: 'var(--red)', flexShrink: 0, border: '3px solid rgba(255,255,255,.2)' },
  teamSection:   { padding: '96px 56px', background: '#fff' },
  teamGrid:      { display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: '24px' },
  teamCard:      { textAlign: 'center' },
  teamAvatar:    { width: '80px', height: '80px', borderRadius: '50%', background: 'var(--black)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'var(--font-display)', fontSize: '28px', color: '#fff', margin: '0 auto 16px', border: '3px solid var(--gold)' },
  teamName:      { fontFamily: 'var(--font-display)', fontSize: '15px', letterSpacing: '1.5px', marginBottom: '4px' },
  teamRole:      { fontSize: '11px', color: '#888', letterSpacing: '.5px', textTransform: 'uppercase', fontWeight: 700 },
  ctaBanner:     { padding: '80px 56px', background: 'var(--black)', textAlign: 'center', borderTop: '3px solid var(--red)' },
  ctaBtnPrimary: { background: 'var(--red)', color: '#fff', padding: '14px 36px', fontFamily: 'var(--font-body)', fontSize: '12px', fontWeight: 700, letterSpacing: '2px', textTransform: 'uppercase', textDecoration: 'none', display: 'inline-block' },
  ctaBtnOutline: { background: 'transparent', color: '#fff', border: '1.5px solid rgba(255,255,255,.3)', padding: '14px 36px', fontFamily: 'var(--font-body)', fontSize: '12px', fontWeight: 700, letterSpacing: '2px', textTransform: 'uppercase', textDecoration: 'none', display: 'inline-block' },
};
